import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AudioPlayerProvider } from './context/AudioPlayerContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AudioPlayerProvider>
    <App />
    </AudioPlayerProvider>
);
reportWebVitals();